export default {
  data() {
    return {
    };
  },
  props: ['title', 'client', 'updated', 'id'],
  template: '<router-link tag="div" v-bind:to="\'/tickets/\' + id" class="ticket shadow clickable">' +
    '<span class="icon"><i class="fal fa-ticket-alt"></i></span>' +
    '<span class="title">{{ title }}</span>' +
    '<span class="client">{{ client }}</span>' +
    '<span class="updated">{{ updated}}</span>' +
    '</router-link>',
};



// WEBPACK FOOTER //
// ./src/components/Ticket.js